import { ReactNode } from 'react';
import { Button, HStack, Icon } from '@chakra-ui/react';
import { Popover } from '@ssar-app/uikit';
import { AiOutlineCheck, AiOutlineClose } from 'react-icons/ai/index.js';

interface UpdatePopoverProps {
  children?: ReactNode;
  onCancel?: () => void;
  onUpdate?: () => void;
  hasError?: boolean;
}
export const UpdatePopover = (props: UpdatePopoverProps) => {
  const { children, onCancel, onUpdate, hasError = false } = props;

  return (
    <Popover
      isOpen
      showFooter={false}
      showArrow={false}
      message={
        <HStack w='full' gap={2}>
          <Button
            bg='primary'
            w='full'
            size='sm'
            gap={2}
            disabled={hasError}
            _hover={{ bg: 'blue.600' }}
            _disabled={{
              bg: 'gray.600',
              _hover: { bg: 'gray.600' },
              cursor: 'not-allowed',
            }}
            leftIcon={<Icon as={AiOutlineCheck} />}
            onClick={onUpdate}
          >
            Update
          </Button>
          <Button
            colorScheme='gray'
            w='full'
            size='sm'
            gap={2}
            leftIcon={<Icon as={AiOutlineClose} />}
            onClick={onCancel}
          >
            Cancel
          </Button>
        </HStack>
      }
      triggerButtonProps={{
        style: { all: 'unset' },
      }}
      contentProps={{
        width: 'sm',
        rootProps: { top: '12px !important', left: '-208px !important' },
      }}
      messageProps={{ boxShadow: '2xl' }}
    >
      {children}
    </Popover>
  );
};
